// Authorization section questionnaire constants
// Extract relevant constants from main questionnaire enum
export enum AuthorizationQuestionnaireItem {
  AUTHORIZATION = 'authorization',
  AUTHORIZATION_AUTHORIZATION = 'authorization/authorization',
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE = 'authorization/authorization/authorization-source'
}
